module.exports = __webpack_public_path__ + "static/media/north-icon.50aec600.svg";